import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";

const CommAutoPremiumFinanceListWarpper = Loadable(
  lazy(() =>
    import(
      "./CommAutoPremiumFinanceListWrapper"
    ).then(({ CommAutoPremiumFinanceListWarpper }) => ({
      default: CommAutoPremiumFinanceListWarpper,
    }))
  )
);
const Premium = Loadable(
  lazy(() =>
    import("./CommAutoPremiumFinance").then(
      ({ CommAutoPremiumFinance }) => ({
        default: CommAutoPremiumFinance,
      })
    )
  )
);

export const CommAutoPremiumFinanceRoutes = [
  {
    path: `/comm-automobile-policy/:customerId/premium-finance/:customerPolicyId/`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <CommAutoPremiumFinanceListWarpper />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/premium-finance/:customerPolicyId/manage`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
  {
    path: `/comm-automobile-policy/:customerId/premium-finance/:customerPolicyId/manage/:premiumNumber`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
        <Premium />
      </AuthorizedRoute>
    ),
  },
];
